import { createMemberDetailsWatch } from "./details/watchMemberDetails";
import { createFormFieldTicketQuantityWatch } from "./form-fields/watchFormFieldTicketQuantity";
import { createFormFieldBookingDetailsWatch } from "./form-fields/watchFormFieldBookingDetails";
import { createFormFieldPeopleWatch } from "./form-fields/watchFormFieldPeople";
import { createFormFieldTicketWatch } from "./form-fields/watchFormFieldTicket";


/**
 * Generates watches for the states data APIs
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Object}
 */
export function createDataWatches(data, form) {
    return {
        member_details: createMemberDetailsWatch(data, form),
    }
}

/**
 * Generates watches for the states form fields
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Object}
 */
export function createFormFieldWatches(data, form) {
    return {
        ticket          : createFormFieldTicketWatch(form, data),
        ticket_quantity : createFormFieldTicketQuantityWatch(form),
        booking_details : createFormFieldBookingDetailsWatch(form),
        people          : createFormFieldPeopleWatch(form),
    }
}